import HeaderFilter from '../../../components/HeaderFilter';
import LineTable from './LineTable';
import { useAuthStore } from '../../../store';
import LineForm from './LineForm';

const LinePage = () => {
  const api = '/lines';
  const moduleName = 'Line';
  const moduleCode = 'LINE';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter />
        <LineTable
          userModuleAccess={userModuleAccess}
          api={api}
          moduleName={moduleName}
          userRole={user?.role}
        />
        <LineForm api={api} moduleName={moduleName} />
      </div>
    </>
  );
};

export default LinePage;
